import React, { useContext, useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/auth';
import { getPermissions } from '../services/firebaseService';

export default function Private({ children, requiredPermissions }) {
  const { signed, userId } = useContext(AuthContext);
  const [permissions, setPermissions] = useState([]);
  const [loadingPermissions, setLoadingPermissions] = useState(true);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (signed && userId) {
      async function fetchPermissions() {
        try {
          const userPermissions = await getPermissions(userId);
          if (!Array.isArray(userPermissions)) {
            console.error('Permissões inválidas ou não encontradas', userPermissions);
            setPermissions([]); // Defina um array vazio como fallback
          } else {
            setPermissions(userPermissions);
          }
          setLoadingPermissions(false);
        } catch (error) {
          console.error('Erro ao obter permissões', error);
          setLoadingPermissions(false);
        }
      }
      fetchPermissions();
    } else {
      setLoadingPermissions(false); // Para evitar o estado de carregamento infinito
    }
  }, [signed, userId]);

  if (loadingPermissions) {
    return <div>Carregando permissões...</div>;
  }

  if (!signed) {
    return <Navigate to="/" state={{ from: currentPath }} />;
  }

  // Verifica as permissões somente após o carregamento
  if (requiredPermissions && permissions.length > 0 && !permissions.includes(requiredPermissions)) {
    return <Navigate to="/acesso_negado" state={{ from: currentPath }} />;
  }
  return children;
}
